<template>
  <div v-if="data?.items?.length" class="cn-rich-advantages-list">
    <RichAdvantages
      v-for="(item, i) in data.items"
      :key="i"
      :data="item"
      :inverted="(i + 1) % 2 === 0"
    />
  </div>
</template>

<script setup lang="ts">
import RichAdvantages from '@/components/RichAdvantages';
// TODO: fix type
interface Props {
  data: { items: any[] };
}
defineProps<Props>();
</script>
